import { styled, alpha } from '@mui/material/styles';
import { Box } from '@mui/material';

const primaryNeutralsDark10 = '#003e471a';
const primaryNeutralsDark80 = 'rgba(0, 62, 71, 0.8)';
const secondaryGrayDark = '#003e4712';
const colorPrimaryBlueDeep = '#0f8594';
const secondaryBlue = '#49baca33';
const primaryGreenDark = '#569720';
const secondaryGreen20 = '#6db33333';
const secondaryOrange = '#f17f16';
const secondaryOrangeDark10 = '#f17f161a';
const colorRed700 = '#ff5454';
const colorYellowDark = '#dfa800';
const colorYellowMain = '#fcc419';
const colorPurple = '#6167f5';

export const TagRoot = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'colorType' && prop !== 'isNowrap' && prop !== 'isClickable' && prop !== 'isClosable',
})<{
  colorType: 'blue' | 'dark' | 'gray' | 'green' | 'orange' | 'red' | 'yellow' | 'purple';
  isNowrap?: boolean;
  isClickable?: boolean;
  isClosable?: boolean;
}>(({ colorType, isNowrap, isClickable, isClosable }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '3px 10px',
  borderRadius: '25px',
  fontSize: '0.75rem',
  lineHeight: 1.5,
  fontWeight: 700,
  width: 'max-content',

  ...(isNowrap && {
    whiteSpace: 'nowrap',
  }),

  ...(isClickable && {
    cursor: 'pointer',
  }),

  ...(isClosable && {
    '& svg': {
      transition: '0.3s',
      cursor: 'pointer',
      opacity: 0,
      width: 0,
    },
    '&:hover svg': {
      marginLeft: '4px',
      width: '16px',
      opacity: 1,
    },
  }),

  ...(colorType === 'dark' && {
    background: primaryNeutralsDark10,
    color: primaryNeutralsDark80,
  }),
  ...(colorType === 'gray' && {
    color: '#003e47',
    background: secondaryGrayDark,
  }),
  ...(colorType === 'blue' && {
    color: colorPrimaryBlueDeep,
    background: secondaryBlue,
  }),
  ...(colorType === 'green' && {
    color: primaryGreenDark,
    background: secondaryGreen20,
  }),
  ...(colorType === 'orange' && {
    color: secondaryOrange,
    background: secondaryOrangeDark10,
  }),
  ...(colorType === 'red' && {
    color: colorRed700,
    background: alpha(colorRed700, 0.2),
  }),
  ...(colorType === 'yellow' && {
    color: colorYellowDark,
    background: alpha(colorYellowMain, 0.2),
  }),
  ...(colorType === 'purple' && {
    color: colorPurple,
    background: alpha(colorPurple, 0.2),
  }),
}));
